import type { DeckPassivePresentation } from '@cards/cards';
import type { CardDefId } from '@cards/engine';
import type { CardInfoData } from './CardInfoCard.js';
import { DECK_PASSIVE_PATTERNS } from './deckPassivePatterns.js';

/**
 * Projects an authored passive into the shared card renderer so it reads like
 * any other card (own art, name, description) with a themed background pattern
 * in its bright accent. Used by the deck-passive catalog, the composition
 * summary and the in-battle passive hover preview. The dedicated catalog
 * section already names the card kind, so the card itself has no redundant type label.
 */
export function deckPassiveInfoData(presentation: DeckPassivePresentation): CardInfoData {
  const tile = DECK_PASSIVE_PATTERNS[presentation.id];
  const accent = presentation.glyph.colors[2];
  return {
    defId: presentation.id as CardDefId,
    kind: 'deck-passive',
    name: presentation.name,
    description: presentation.description,
    glyph: presentation.glyph,
    metaLabel: '',
    keywords: [],
    hideKeywords: true,
    ...(tile === undefined || accent === undefined
      ? {}
      : { pattern: { colors: [accent], rows: tile } }),
  };
}
